import { useState, useRef, React} from 'react';
import emailjs from '@emailjs/browser';
import { original, rose, vaporwave, matrix } from 'react95/dist/themes';
import { BrowserRouter, Router, Routes, Route, Link, useNavigate} from "react-router-dom";
import { createGlobalStyle, ThemeProvider, createTheme} from 'styled-components';
import styled from 'styled-components';
import "../Styles/style.css"
import {
    AppBar,
  Button,
  MenuList,
  MenuListItem,
  ScrollView,
  Separator,
  Toolbar,
    Frame,
  Window,
    Handle,
    
  WindowContent,
  WindowHeader,
    TextInput,
    styleReset
} from 'react95';

const AboutPage = () => {
    const imgBox = useRef(null);
    const descBox = useRef(null);
    
    const navigate = useNavigate();
    
    const handleRedirect = (dir) => {
            navigate(dir);
        };
    
    const formRef = useRef();
     const [status, setStatus] = useState('idle'); // idle | sending | success | error

     const handleSubmit = async (e) => {
       e.preventDefault();
       setStatus('sending');

       try {
           
           console.log(process.env);
         await emailjs.sendForm(
            process.env.REACT_APP_EMAILJS_SERVICE_ID,
            process.env.REACT_APP_EMAILJS_TEMPLATE_ID,
            formRef.current,
            process.env.REACT_APP_EMAILJS_PUBLIC_KEY
         );
         setStatus('success');
         formRef.current.reset();
       } catch (err) {
         console.error(err);
         setStatus('error');
       }
     };

    
    return (
            <ThemeProvider theme={rose}>
            <Window resizable className='window' style={{ display: 'block',width: '80%', height: '75vh' }}>
            <WindowHeader className='window-title' style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <span>Contact Me</span>
            <Button style={{ marginRight: '2px', width: '20px', height: '20px', padding: 0 }} onClick={() => handleRedirect('/')}>
            <span style={{ fontWeight: 'bold', fontSize: '12px' }}>✕</span>
            </Button>
            </WindowHeader>
            
            <WindowContent style={{ height: 'calc(100% - 33px)', padding: 0 }}>
            <Frame variant='well' className='footer' style={{ height: '99%', width: '100%', margin: 0, display: 'flex' }}>
                
                  <ScrollView style={{ flex: 1}}>
                      <div style={{ padding: '1rem' }}>
                      <form ref={formRef} onSubmit={handleSubmit}>
                        <TextInput type="text" name="from_name" placeholder="Your name" required />
                        <TextInput type="email" name="from_email" placeholder="Your email" required />
                      <TextInput type="subject" name="subject" placeholder="Subject" required />
                      <TextInput multiline rows={8} name="message" placeholder="Your message" required />

                        <Button type="submit" disabled={status === 'sending'}>
                          {status === 'sending' ? 'Sending...' : 'Send Message'}
                        </Button>

                        {status === 'success' && <p>Message sent successfully!</p>}
                        {status === 'error' && <p>Something went wrong. Please try again.</p>}
                      </form>
                      </div>
                  </ScrollView>
                
            
              </Frame>
            
            
            </WindowContent>
            
          </Window>
          
          
    </ThemeProvider>
  );
}

export default AboutPage;
